/*jshint esversion: 6 */
class Credential {
   constructor(accessKey, secretKey) {
      this._id = '';
      this.accessKey = accessKey || '';
      this.secretKey = secretKey || '';
      this.isActive = true;
   }
}

export { Credential };